import { useEffect } from 'react'

const applyTheme = (tg: TelegramWebApp) => {
  const root = document.documentElement
  const theme = tg.themeParams || {}

  if (theme.bg_color) root.style.setProperty('--tg-bg-color', theme.bg_color)
  if (theme.text_color) root.style.setProperty('--tg-text-color', theme.text_color)
  if (theme.hint_color) root.style.setProperty('--tg-hint-color', theme.hint_color)
  if (theme.link_color) root.style.setProperty('--tg-link-color', theme.link_color)
  if (theme.button_color) root.style.setProperty('--tg-button-color', theme.button_color)
  if (theme.button_text_color) root.style.setProperty('--tg-button-text-color', theme.button_text_color)
  if (theme.secondary_bg_color) root.style.setProperty('--tg-secondary-bg-color', theme.secondary_bg_color)

  document.body.classList.add('telegram-webapp')
  document.body.classList.toggle('telegram-dark', tg.colorScheme === 'dark')

  if (tg.setHeaderColor && theme.secondary_bg_color) tg.setHeaderColor(theme.secondary_bg_color)
  if (tg.setBackgroundColor && theme.bg_color) tg.setBackgroundColor(theme.bg_color)
}

const applyViewport = (tg: TelegramWebApp) => {
  const height = tg.viewportStableHeight || tg.viewportHeight;
  if (height > 0) {
    document.documentElement.style.minHeight = `${height}px`;
    document.body.style.minHeight = `${height}px`;
  }
};

export const useTelegramWebApp = () => {
  useEffect(() => {
    const tg = window.Telegram?.WebApp
    if (!tg) return

    tg.ready()
    tg.expand()
    applyTheme(tg)
    applyViewport(tg)

    const onThemeChanged = () => applyTheme(tg)
    const onViewportChanged = () => applyViewport(tg)
    tg.onEvent('themeChanged', onThemeChanged)
    tg.onEvent('viewportChanged', onViewportChanged)

    return () => {
      tg.offEvent('themeChanged', onThemeChanged)
      tg.offEvent('viewportChanged', onViewportChanged)
    }
  }, [])
}

export const getTelegramDisplayName = () => {
  const user = window.Telegram?.WebApp?.initDataUnsafe?.user
  if (!user) return null
  if (user.username) return user.username
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ').trim()
  return fullName.length > 0 ? fullName : null
}

export const getTelegramStartParam = () => {
  const startParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param
  if (!startParam) return null
  const trimmed = startParam.trim()
  return trimmed.length > 0 ? trimmed : null
}
